// services/api/UsuariosApi.ts
import api from '../../utils/axios';
import { CreateUsuarioDto, UpdateUsuarioDto, Usuario } from '../../components/types/usuario.types';

const BASE_URL = process.env.REACT_APP_API_URL || '';

export class UsuariosApi {
    static async findAll(): Promise<Usuario[]> {
        try {
            const response = await api.post(`${BASE_URL}/users/findAll`);
            return response.data;
        } catch (error) {
            throw new Error('Error al obtener usuarios');
        }
    }

    static async findOne(id: number) {
        try {
            const response = await api.post(`${BASE_URL}/users/findOne/${id}`);
            return response.data;
        } catch (error) {
            throw new Error('Error al obtener el usuario');
        }
    }

    static async create(data: CreateUsuarioDto): Promise<Usuario> {
        try {
            const response = await api.post(`${BASE_URL}/auth/register`, data);
            return response.data;
        } catch (error) {
            throw new Error('Error al crear usuario');
        }
    }

    static async update(id: number, data: UpdateUsuarioDto): Promise<Usuario> {
        try {
            const response = await api.post(`${BASE_URL}/users/update/${id}`, data);
            return response.data;
        } catch (error) {
            throw new Error('Error al actualizar usuario');
        }
    }

    static async softDelete(id: number): Promise<{ message: string }> {
        try {
            const response = await api.post(`${BASE_URL}/users/softDelete/${id}`);
            return response.data;
        } catch (error) {
            throw new Error('Error al eliminar usuario');
        }
    }
}
